function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// show the first tabs by default on load - data-default-open
function openDefaultTabs() {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
}

// if the URL has a hash matching one of this page's tab panels (e.g. a direct
// link from an email to a specific "featured products" tab like Emollients),
// activate that tab and scroll to it instead of leaving the default tab open
function openTabFromHash() {
  const hash = window.location.hash ? window.location.hash.slice(1) : "";
  if (!hash) return false;

  const target = document.getElementById(hash);
  if (!target) return false;

  const button = document.querySelector('[onclick*="\'' + hash + '\'"]');
  if (!button) return false;

  button.click();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}

openDefaultTabs();
openTabFromHash();

window.addEventListener("shopify:section:load", () => {
  openDefaultTabs();
  openTabFromHash();
});

window.addEventListener("hashchange", openTabFromHash);
